import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  preview() {
    const template = document.querySelector('textarea#form_template_template').value
    const formType = document.querySelector('select#form_template_form_type').value
    const assessorOrgId = document.querySelector('select#form_template_assessor_org_id').value
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    // Create a hidden form and submit to a new tab
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.urlValue
    form.target = '_blank'

    const fields = {
      template: template,
      form_type: formType,
      assessor_org_id: assessorOrgId,
      authenticity_token: csrfToken
    }

    for (const [name, value] of Object.entries(fields)) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = name
      input.value = value
      form.appendChild(input)
    }

    document.body.appendChild(form)
    form.submit()
    form.remove()
  }
}
